import Vue from 'vue';

// v-dialogDrag: 弹窗拖拽
Vue.directive('newDialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cursor = 'move';
    //弹框可拉伸最小宽高

    let minWidth = 500;

    let minHeight = 300;

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onmousedown = (e) => {
      // e.preventDefault();
      e.stopPropagation();
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;
      const screenWidth = document.body.clientWidth; // body当前宽度
      const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)

      const dragDomWidth = dragDom.offsetWidth; // 对话框宽度
      const dragDomheight = dragDom.offsetHeight; // 对话框高度

      const minDragDomLeft = dragDom.offsetLeft;
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

      const minDragDomTop = dragDom.offsetTop;
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;


      // 获取到的值带px 正则匹配替换
      let styL, styT;

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left === 'auto') {
        styL = 0;
        styT = 0;
      } else if (sty.left.indexOf('%') !== -1) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      } else {
        styL = +sty.left.replace(/px/g, '');
        styT = +sty.top.replace(/px/g, '');
      };

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        // 边界处理
        if (-(left) > minDragDomLeft) {
          left = -(minDragDomLeft);
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }

        if (-(top) > minDragDomTop) {
          top = -(minDragDomTop);
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }


        // 移动当前元素
        dragDom.style.left = `${left + styL}px`;
        dragDom.style.top = `${top + styT}px`;
      

        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };





    }
  dragDom.onmousemove = function (e) {
      
    const rect = dragDom.getBoundingClientRect();
    const mouseX = e.clientX - rect.left; // 获取鼠标相对于元素左边界的水平距离
    const mouseY = e.clientY - rect.top; // 获取鼠标相对于元素上边界的垂直距离
    const elementWidth = rect.width;
    const elementHeight = rect.height;
    var rightBorderX = rect.right; 
    var distanceToRight = rightBorderX - e.clientX;
    // console.log(mouseX,'mousex')
    // console.log(distanceToRight,'distanceToRight')

    const isAtBottomLeft = mouseX < 10 && mouseY > elementHeight - 10; // 左下角判定条件：鼠标横坐标小于 30 且纵坐标大于元素高度减去 30
    const isAtBottomRight = mouseX > elementWidth - 10 && mouseY > elementHeight - 10; // 右下角判定条件：鼠标横坐标大于元素宽度减去 30 且纵坐标大于元素高度减去 30
   if (isAtBottomLeft) {
      $(".customHeight2 .el-dialog__body").css("cursor", "sw-resize");
    } else if (isAtBottomRight) {
      $(".customHeight2 .el-dialog__body").css("cursor", "se-resize");
    }else if(mouseX  <10){
      $(".customHeight2 .el-dialog__body").css("cursor", "w-resize");
    }else if(distanceToRight  <10){
      $(".customHeight2 .el-dialog__body").css("cursor", "e-resize");
    }else{
      $(".customHeight2 .el-dialog__body").css("cursor", "default");
    }

    dragDom.onmousedown = (e) => {

      $(".courseSubDialog").css("pointer-events", "auto");

      const clientX = e.clientX;

      const clientY = e.clientY;

      let elW = dragDom.clientWidth;

      let elH = dragDom.clientHeight;

      let EloffsetLeft = dragDom.offsetLeft;

      let EloffsetTop = dragDom.offsetTop;
      let originalWidth = dragDom.offsetWidth;

      dragDom.style.userSelect = 'none';

     
      

      let ELscrollTop = el.scrollTop;
      //判断点击的位置是不是为头部

      if (clientX > EloffsetLeft && clientX < EloffsetLeft + elW && clientY > EloffsetTop && clientY < EloffsetTop + 100) {
        //如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;
        document.onmousemove = function (e) {
          //e.preventDefault(); // 移动时禁用默认事件
          //顶部鼠标拖拽位置
          if (clientY > EloffsetTop && clientY < EloffsetTop + 10) {

            //往上拖拽

            if (clientY > e.clientY) {
              dragDom.style.top = e.clientY + 'px';
              dragDom.style.marginTop = 0 + 'px';
              dragDom.style.height = elH + (clientY - e.clientY) + 'px';

            }
            //往下拖拽

            if (clientY < e.clientY) {
              if (dragDom.style.height < minHeight) {

              } else {
                dragDom.style.top = e.clientY + 'px';
                dragDom.style.marginTop = 0 + 'px';
                dragDom.style.height = elH - (e.clientY - clientY) + 'px';
              }
            }


          }

        };
        document.onmouseup = function (e) {
          document.onmousemove = null;
          document.onmouseup = null;

        };
      } else {

        document.onmousemove = function (e) {
          //e.preventDefault(); // 移动时禁用默认事件

          //左侧鼠标拖拽位置

          if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {

            //往左拖拽

            if (clientX > e.clientX) {
              
              dragDom.style.left =( e.clientX -10)+ 'px';
              dragDom.style.width = elW + ((clientX - e.clientX+10)) + 'px';
              // 
          
              

            }

            //往右拖拽

            if (clientX < e.clientX) {

              if (dragDom.clientWidth < minWidth) {

              } else {
                dragDom.style.left = e.clientX + 'px';
                dragDom.style.width = elW - (e.clientX - clientX) + 'px';

              }

            }

          }

          //右侧鼠标拖拽位置

          if (clientX > EloffsetLeft + elW - 10 && clientX < EloffsetLeft + elW) {

            //往左拖拽

            if (clientX > e.clientX) {

              if (dragDom.clientWidth < minWidth) {

              } else {

                dragDom.style.width = elW - (clientX - e.clientX) + 'px';

              }

            }

            //往右拖拽

            if (clientX < e.clientX) {

              dragDom.style.width = elW + (e.clientX - clientX) + 'px';

            }

          }

          //底部鼠标拖拽位置

          if (ELscrollTop + clientY > EloffsetTop + elH - 20 && ELscrollTop + clientY < EloffsetTop + elH) {

            //往上拖拽

            if (clientY > e.clientY) {

              if (dragDom.clientHeight < minHeight) {

              } else {

                dragDom.style.height = elH - (clientY - e.clientY) + 'px';

              }

            }

            //往下拖拽

            if (clientY < e.clientY) {

              dragDom.style.height = elH + (e.clientY - clientY) + 'px';

            }

          }

        };

      }

      //拉伸结束

      document.onmouseup = function (e) {
        $(".courseSubDialog").css("pointer-events", "none");
        document.onmousemove = null;
        document.onmouseup = null;
      };

    }

  }



  }
});



// WEBPACK FOOTER //
// ./src/libs/drag/DialogDirectives.js